// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import InfosBox from "@store/Library/Components/Toolkit/InfosBox";
import React, { FC } from "react";

type Props = WidgetProps;

const CheckoutReviewAndSubmitCartMessages: FC<Props> = () => {
    const cart = useAppSelector(state => {
        const { cartId } = state.pages.checkoutReviewAndSubmit;
        return cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    });

    if (!cart?.messages?.length || cart?.messages?.length <= 0) {
        return null;
    }

    return (
        <InfosBox type="warning" size="small">
            {cart?.messages?.map(message => {
                return <Typography key={message}>{message}</Typography>;
            })}
        </InfosBox>
    );
};

const widgetModule: WidgetModule = {
    component: CheckoutReviewAndSubmitCartMessages,
    definition: {
        group: "Checkout - Review & Submit",
        displayName: "Cart Messages",
        allowedContexts: ["CheckoutReviewAndSubmitPage", "OrderConfirmationPage"],
    },
};

export default widgetModule;
